import React , { Suspense, lazy , useState , useEffect , useContext } from "react";
import { Link , NavLink, Outlet  } from "react-router-dom";
import Header from './HeaderHome';
import Footer from './FooterHome';
import  { WebAssetsContext }  from "../../App";
const Webassets = React.lazy(() => import('../../Webassets'));
const LayoutHome = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  return (
    <>
    <Suspense>
      <Webassets/>
      <Header isloggedIn={props.isloggedIn} customerLogout={props.customerLogout} customer={props.customer}  />
        <Outlet />  
      <Footer />
    </Suspense>
    </>
  )
};

export default LayoutHome;